import {
  FormDataPost,
  Get,
  getAPIUrl,
  Post,
} from "../../ApiServices/apiMethod";

export const ChartEndpoint = {
  getfetchResult: "number/previous-result?slug=",
};

export const getfetchResult = (param = "") => {
  const url = getAPIUrl(ChartEndpoint.getfetchResult, param);
  return Get(url);
};
